export default "__VITE_ASSET__DzKf0A6k__"